export default __webpack_public_path__ + "static/crayon-880d05f2182c5ead2b408df522bea261.mp4";